module.exports = __webpack_public_path__ + "img/bg-ftr_sp.85b78e4c.jpg";